import URL from '../api_url';

export const AUTH_API = `${URL}/auth`;

export const AUTH_RECOVERY_API = `${URL}/auth/recovery-password`;

export const AUTH_VALIDATE_API = `${URL}/auth/validate`;

